import api from "../../api/cofocusAPI";

const UnsubscribeAPI = {
  async unsubscribeUserFromEmailType(unsubscribeEncryption) {
    return await api.getResponseData({
      url: `api/users/unsubscribe/${unsubscribeEncryption}`,
      method: "post",
      withCredentials: false,
    });
  },
};

export default UnsubscribeAPI;
